import Bloc from './Bloc.js';
import Types from './Types.js';

export default class SplitDamage extends Bloc {

	constructor (src, ctx) {

		super("splitdamage", src, ctx, true);
		this.f = (src, ins) => {
			let hits = Math.max(1, ins[3]);
			let direct = ins[4] !== false;
			let total = direct ? ins[1].modifyDamageOut(ins[2], src) : ins[2];
			let base = Math.floor(total / hits);
			let remainder = total % hits;
			let index = ins[5];
			let dealt = 0;
			let dead = false;
			let start = index === undefined || index === null ? 0 : index;
			let end = index === undefined || index === null ? hits : index + 1;

			for (let i = start; i < end; i++) {
				let target = this.computeSingle(0);
				if (!target)
					break;
				if (target.removedFromFight || (target.id?.type === "enemy" && target.dead && target.removed))
					continue;
				let damage = base + (i < remainder ? 1 : 0);
				let result = target.damage(damage, ins[1], direct);
				dealt += result.dmg;
				dead = dead || target.dead;
			}

			return [dealt, dead, 0, total];
		};
		this.types = [Types.entity, Types.entity, Types.int, Types.int, Types.bool, Types.int];
	}
}
